import { NoteGetRequestParams, NoteSearchResponse } from '@lio/api-types';
import { noteQueryKey } from '@services/note/keys';
import { useQueryClient, useMutation, InfiniteData } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const usePinNote = () => {
  const queryClient = useQueryClient();
  const client = useClient();
  const result = useMutation({
    mutationFn: ({ noteId }: NoteGetRequestParams) =>
      client.post(`note/${noteId}/toggle-pinned`, {
        json: { id: noteId },
      }),
    onMutate: async (data) => {
      await queryClient.cancelQueries({ queryKey: noteQueryKey.search });

      const previousNotes = queryClient.getQueriesData<InfiniteData<NoteSearchResponse>>({
        queryKey: noteQueryKey.search,
      });

      queryClient.setQueriesData<InfiniteData<NoteSearchResponse>>(
        { queryKey: noteQueryKey.search },
        (previousState) =>
          previousState
            ? {
                ...previousState,
                pages: previousState.pages.map((page) => ({
                  items: page.items.map((note) =>
                    note.id === data.noteId
                      ? {
                          ...note,
                          isPinned: !note.isPinned,
                        }
                      : note,
                  ),
                  pagination: page.pagination,
                })),
              }
            : previousState,
      );
      return { previousNotes };
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: noteQueryKey.search });
    },
    onError: (err, newTodo, context) => {
      queryClient.setQueryData(noteQueryKey.search, context?.previousNotes);
    },
  });
  return { ...result, pinNote: result.mutate };
};
